/**
 * Copyright (C) 2026 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import { OrbitPointsBySvName, SpaceVehicleId, SpaceVehiclePositionsBySvName } from '../../shared/entities/haloNet';
import { Action, ActionCreators } from './actions';

export interface HaloNetSpaceVehiclesState {
  spaceVehicles: SpaceVehicleId[];
  orbitsBySpaceVehicleId: OrbitPointsBySvName;
  currentPositionsBySvName: SpaceVehiclePositionsBySvName;

  isRequestingSpaceVehicles: boolean;
  isRequestingOrbits: boolean;

  spaceVehiclesError?: string;
  orbitsError?: string;
}

export const initialHaloNetSpaceVehiclesState: HaloNetSpaceVehiclesState = {
  spaceVehicles: [],
  orbitsBySpaceVehicleId: {},
  currentPositionsBySvName: {},

  isRequestingSpaceVehicles: false,
  isRequestingOrbits: false,

  spaceVehiclesError: undefined,
  orbitsError: undefined,
};

export default function haloNetSpaceVehiclesReducer(
  state: HaloNetSpaceVehiclesState = initialHaloNetSpaceVehiclesState,
  action: Action,
): HaloNetSpaceVehiclesState {
  let partialState: Partial<HaloNetSpaceVehiclesState> | undefined;

  switch (action.type) {
    case ActionCreators.RequestHaloNetSpaceVehicles.type:
      partialState = {
        isRequestingSpaceVehicles: true,
        spaceVehiclesError: undefined,
      };
      break;

    case ActionCreators.ReceivedHaloNetSpaceVehiclesSuccess.type:
      partialState = {
        spaceVehicles: action.payload.response || [],
        isRequestingSpaceVehicles: false,
        spaceVehiclesError: undefined,
      };
      break;

    case ActionCreators.ReceivedHaloNetSpaceVehiclesError.type:
      partialState = {
        isRequestingSpaceVehicles: false,
        spaceVehiclesError: action.payload?.message,
      };
      break;

    case ActionCreators.RequestHaloNetSpaceVehicleOrbits.type:
      partialState = {
        isRequestingOrbits: true,
        orbitsError: undefined,
      };
      break;

    case ActionCreators.ReceivedHaloNetSpaceVehicleOrbitsSuccess.type:
      partialState = {
        orbitsBySpaceVehicleId: action.payload.response || {},
        isRequestingOrbits: false,
        orbitsError: undefined,
      };
      break;

    case ActionCreators.ReceivedHaloNetSpaceVehicleOrbitsError.type:
      partialState = {
        isRequestingOrbits: false,
        orbitsError: action.payload?.message,
      };
      break;

    case ActionCreators.UpdateHaloNetSpaceVehiclePositions.type:
      partialState = {
        currentPositionsBySvName: action.payload?.positionsBySvName || {},
      };
      break;

    case ActionCreators.CancelHaloNetSpaceVehiclePolls.type:
      partialState = {
        isRequestingSpaceVehicles: false,
        isRequestingOrbits: false,
      };
      break;

    default:
      return state;
  }

  return { ...state, ...partialState };
}
